import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const GetOperatorsList = async (dispatch) => {
  dispatch(setShowPreloader(true));
  const response = await AxiosGetMethod("org/operators-list");
  dispatch(setShowPreloader(false));

  if (response?.status === 200) {
    return response.data.data || [];
  }

  if (response?.status === 401) {
    HandleLogout();
  }

  ErrorToast("Something went wrong on fetching enterprise data");
  return null;
};

export default GetOperatorsList;
